module.exports = __webpack_public_path__ + "img/b2-1.92ebda9.png";